import { render, staticRenderFns } from "./TermsAndConditionsComponent.vue?vue&type=template&id=53a29228"
import script from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsComponent.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsComponent.vue?vue&type=style&index=0&id=53a29228&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports